import * as s from "./website-content.scss";
import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {WebsiteBlackBlockComponent} from "../black/block/WebsiteBlackBlockComponent";
import {Resources} from "../../../../../resources/Resources";
import {
    WebsiteBlackTestimonialPresentationComponent
} from "../black/testimonial/presentation/WebsiteBlackTestimonialPresentationComponent";
import {WebsiteBlackReviewComponent} from "../black/review/WebsiteBlackReviewComponent";
import {WebsiteBlackUnionLineComponent} from "../black/union/line/WebsiteBlackUnionLineComponent";
import {
    WebsiteBlackTestimonialResultsComponent
} from "../black/testimonial/results/WebsiteBlackTestimonialResultsComponent";
import {Network} from "../../../../../network/Network";

export class WebsiteContentTestimonialRayssaComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTestimonialPresentationComponent({
                            title: "Rayssaguel crée du contenu et optimise son SEO avec Sedestral",
                            stats: [
                                {value: "+116%", label: "clics par rapport à l'année dernière"},
                                {value: "+67%", label: "impressions par rapport à l'année dernière"},
                                {value: "+39%", label: "Mots-clés totaux référencés"}
                            ],
                            customerName: "La Ferme de Rayssaguel ",
                            customerDescription: "<p>La Ferme de Rayssaguel, une tradition fermière au cœur du Tarn.</p><p>Depuis plus de 50 ans, la Ferme de Rayssaguel cultive avec passion ses terres et élève veaux, bœufs, canards et volailles dans un cadre naturel préservé, à proximité d’Albi. La famille Rolland maîtrise chaque étape : de la culture des céréales à l’élevage, jusqu’à la transformation artisanale des produits à la ferme. Cette approche locale et familiale garantit des produits fermiers authentiques, savoureux et respectueux des animaux comme de l’environnement.</p><br><p>Ils proposent leurs viandes et spécialités du terroir en vente directe à la ferme ou en ligne via leur boutique Prestashop, où ils expédient partout en France des produits 100% fermiers et français.</p>",
                            customerImage: NetworkVendor.image("customer-rayssa.webp")
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackReviewComponent({
                            name: "Alexandre",
                            role: "Responsable du Digital",
                            review: "<p>Depuis janvier 2025, nous utilisons pleinement la solution Sedestral pour notre boutique rayssaguel.com, et l’impact est remarquable.</p><p>L’outil nous fait gagner un temps considérable dans la gestion des contenus, le traitement des données et l’optimisation SEO, tout en réduisant le nombre d’applications utilisées.</p><p>L’IA intégrée, alliée à une équipe de développement réactive et innovante, nous permet de déployer une stratégie de mots-clés solide et durable.</p><p>Sedestral nous aide à attirer plus de visiteurs, à offrir un contenu de qualité à nos lecteurs et à faire évoluer sereinement notre boutique sur le long terme.</p><p>Simple, puissant et pensé pour les professionnels du digital, nous sommes fiers d’être partenaires de cette solution accueillante et orientée utilisateur.</p>",
                            noStars: true,
                            color: "white",
                            title: Resources.t("words.testimonialCustomerTitle"),
                            tiny: true,
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackUnionLineComponent("white"))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackBlockComponent({
                            text: Resources.t("words.testimonialCtaQuestion"),
                            color: "black",
                            buttons: [
                                {
                                    name: Resources.t("words.testimonialRequestDemo"),
                                    color: "black",
                                    link: Network.router.pages.getUrlWithPath('schedule')
                                },
                                {
                                    name: Resources.t("words.testimonialTryFree"),
                                    link: Network.router.pages.getPanelUrl('signup')
                                }
                            ]
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackTestimonialResultsComponent([
                                {
                                    title: "+116% de clics",
                                    image: NetworkVendor.image("customer-rayssa-clics.webp"),
                                    description: "Grâce à l’optimisation et à la création de contenu avec Sedestral, Rayssaguel a enregistré une augmentation moyenne de +116 % du nombre de clics par jour par rapport à l’année précédente."
                                },
                                {
                                    title: "+67% impressions",
                                    image: NetworkVendor.image("customer-rayssa-impressions.webp"),
                                    description: "En combinant l’optimisation SEO de Sedestral et son module de blog gratuit pour PrestaShop, Rayssaguel a vu le nombre moyen de clics quotidiens grimper de 67 % par rapport à l’année précédente."
                                }
                            ]))}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
